<template>
  <div class="inner">
    <div>
      <v-card class="card-wrap">
        <p class="text-center my-2 pointer" @click="forward(node)">{{ node.alias }}</p>
      </v-card>
      <v-sheet class="d-flex" :color="node.color" height="5"></v-sheet>
    </div>
    <div style="height: calc(100% - 65px)">
      <div class="h-20 mt-1">
        <v-card class="card-wrap">
          <v-card-title>User</v-card-title>
          <div class="box">
            <user :node="node" />
          </div>
        </v-card>
      </div>
      <div class="h-20 mt-1">
        <v-card class="card-wrap">
          <v-card-title>JVM</v-card-title>
          <div class="box">
            <jvm :node="node" />
          </div>
        </v-card>
      </div>
      <div class="h-20 mt-1">
        <v-card class="card-wrap">
          <v-card-title>Performance</v-card-title>
          <div class="box">
            <performance :node="node" />
          </div>
        </v-card>
      </div>
      <div class="h-20 mt-1">
        <v-card class="card-wrap">
          <v-card-title>OS</v-card-title>
          <div class="box">
            <os :node="node" />
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import User from './User.vue';
import Jvm from './Jvm.vue';
import Performance from './Performance.vue';
import Os from './Os.vue';
import instanceable from './mixins/instanceable';

export default {
  mixins: [instanceable],
  components: {
    User,
    Jvm,
    Performance,
    Os,
  },
  computed: {
    ...mapGetters('common/system', ['getDescendantsById']),
  },
  methods: {
    forward(p) {
      // console.log('in whole/java/Java.vue. forward p', p);
      const query = this.getDescendantsById(p.systemId).length > 1 ? { d: p.id } : {};
      this.$router.push({ path: `/views/overview/system/${p.systemId}`, query });
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
